import React, { useEffect, useRef, useState } from "react"
import styles from "./hero-knowledgebase-page.module.scss"
import { graphql, useStaticQuery } from "gatsby"
import { initSearch } from "../../../../../knowledgebase/components/knowledgebase-utils"

const HeroKnowledgeBasePage = ({ location, onSearchResults }) => {
  const searchInput = useRef(null)
  const [query, setQuery] = useState('')
  useEffect(() => {
    if (location) {
      const searchParams = new URLSearchParams(location.search);
      if (searchParams.has("q")) setQuery(searchParams.get("q"))
      if (searchParams.has("q")) onSearchResults(
        search(searchParams.get("q"))
      )
    }
  }, [location])

  const { allMarkdownRemark, KnowledgebaseIndex } = useStaticQuery(knowledgebaseSearchQuery)
  const store = {}
  allMarkdownRemark.edges.forEach(({ node }) => {
    const path = `/knowledgebase/post${node.frontmatter.path}`
    store[path] = node
  })
  const search = initSearch(KnowledgebaseIndex.index, store)
  const onSearch = (e) => {
    if (onSearchResults) {
      e.preventDefault()
      setQuery(searchInput.current.value)
      const searchResults = search(searchInput.current.value)
      onSearchResults(searchResults)
    }
  }

  return (
  <div className={styles.hero}>
    <div className={`container ${styles.container}`}>
      <div className={styles.heading}>База знаний</div>
      <form action="/knowledgebase/search/" className={styles.search} onSubmit={onSearch}>
        <input
          className={styles.input}
          type="text"
          placeholder="Как добавить..."
          ref={searchInput}
          name="q"
          value={query}
          onChange={e => setQuery(e.target.value)}
        />
        <button className={styles.btn} type="submit">
          Найти
        </button>
      </form>
    </div>
  </div>
)}

export default HeroKnowledgeBasePage

export const knowledgebaseSearchQuery = graphql`
  query KnowledgebaseSearchQuery {
    allMarkdownRemark(
      filter: {
        fileAbsolutePath: {regex: "/src/knowledgebase/"}
        frontmatter: { path: {ne: null} }
      }
    ) {
      edges {
        node {
          frontmatter {
            cover {
              childImageSharp {
                sm: fluid(maxWidth: 470) {
                  ...GatsbyImageSharpFluid_noBase64
                }
                mob: fluid(maxWidth: 835) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            lead {
              childImageSharp {
                fixed(height: 400) {
                  ...GatsbyImageSharpFixed
                }
              }
            }
            excerpt
            path
            title
            category
            mark
          }
          timeToRead
        }
      }
    }
    KnowledgebaseIndex
  }
`